/**
 * Swiper 7.4.1
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination, freemode & keyboard modules:
import Swiper, { Navigation, Pagination, FreeMode, Keyboard } from 'swiper';

/**
* Page Standard Swiper
* Default + freemode
*/
// Default
const psSwiper = Array.from(document.getElementsByClassName('js-swiper-page-standard'));

const swiperResizeCallBack = (swiper) => {
  for (let index = 0; index < swiper.$el.length; index++) {
    const element = swiper.$el[index];
    element.classList.toggle('swiper-no-swiping', window.innerWidth >= 768)
  }
}

if (psSwiper.length) {
  for (const swiper of psSwiper) {

    // Swiper instance
    const psSwiperInstance = new Swiper(swiper, {
      modules: [Navigation, Pagination, Keyboard],
      slidesPerView: 1,
      speed: 700,
      navigation: {
        nextEl: swiper.querySelector('.swiper-button-next'),
        prevEl: swiper.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el:  swiper.querySelector('.swiper-pagination'),
        clickable: true
      },
      keyboard: true,
      init: false,
      spaceBetween: 80,
      breakpoints: {
        768: {
          grabCursor: false,
          pagination: false,
          slidesPerView: 2,
          spaceBetween: 20
        }
      },
      on: {
        afterInit: (swiper) => swiperResizeCallBack(swiper),
        resize: (swiper) => swiperResizeCallBack(swiper)
      }
    })

    // Init only if there is 2 or more slides
    const nbSlides = Array.from(swiper.getElementsByClassName('swiper-slide'));

    if (nbSlides.length > 1) {
      psSwiperInstance.init();
    }
  }
}

// Freemode
const swiperFreemode = Array.from(document.getElementsByClassName('js-swiper-freemode'));
if (swiperFreemode.length) {
  for (const swiper of swiperFreemode) {

    // Swiper instance
    const swiperFreeModeInstance = new Swiper(swiper, {
      modules: [Navigation, Pagination, FreeMode, Keyboard],
      slidesPerView: 'auto',
      centeredSlides: (Foundation.MediaQuery.current === 'small') ? false : true,
      grabCursor: true,
      freeMode: true,
      spaceBetween: (Foundation.MediaQuery.current === 'small') ? 16 : 32,
      speed: 700,
      navigation: {
        nextEl: swiper.querySelector('.swiper-button-next'),
        prevEl: swiper.querySelector('.swiper-button-prev'),
      },
      keyboard: true,
      init: false
    })

    // Init only if there is 2 or more slides
    const nbSlides = Array.from(swiper.getElementsByClassName('swiper-slide'));

    if (nbSlides.length > 1) {
      swiperFreeModeInstance.init();
    }
  }
}

